(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-inventory-status"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('nex-cart-inventory')) return;
    let formSequence = 0;
    class NexCartInventory extends HTMLElement {
      connectedCallback() {
        this.ready = () => this.start();
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.ready, { once: true });
        else this.start();
      }
      start() {
        if (!this.isConnected || this.started) return;
        this.started = true;
        this.scope = this.closest('.gdab__cart, .cart-page__sheet');
        if (!this.scope) return;
        this.map = new Map();
        this.mergeMaps(this);
        try {
          this.cartData = JSON.parse(this.querySelector('[data-cart-inventory-cart]').textContent);
          this.cartData.items = this.cartData.items.filter(Boolean);
        } catch { this.cartData = { items: [], item_count: 0, total_price: 0 }; }
        this.cartHydrating = this.cartData.items.length > 0;
        this.click = event => this.onClick(event);
        this.submit = event => {
          if (event.target.matches('.gdab__checkout-form') && (this.blocked || window.NexDock?.readOnly)) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        };
        this.scope.addEventListener('click', this.click, true);
        this.scope.addEventListener('submit', this.submit, true);
        this.lineObserver = new MutationObserver(() => this.sync());
        const lines = this.scope.querySelector('.gdab__cart-lines');
        if (lines) this.lineObserver.observe(lines, { childList: true });
        this.recheck = () => this.refreshCurrent();
        window.addEventListener('pageshow', this.recheck);
        window.addEventListener('focus', this.recheck);
        if (this.dataset.mode === 'drawer') {
          customElements.whenDefined('nex-gdab').then(() => {
            if (!this.isConnected) return;
            this.host = this.closest('nex-gdab');
            if (!this.host) return;
            this.originalRender = this.host.renderCart;
            this.originalTotals = this.host.renderTotals;
            const owner = this;
            this.renderHook = function(cart, ...args) {
              const result = owner.originalRender.call(this, cart, ...args);
              if (args[0] !== true && this.getAttribute('data-gdab-state') === 'cart') owner.refreshCurrent();
              return result;
            };
            this.totalsHook = function(cart, ...args) {
              const result = owner.originalTotals.call(this, cart, ...args);
              owner.nativeDisabled = Boolean(owner.scope.querySelector('.gdab__checkout')?.disabled);
              owner.cartData = cart;
              if (Array.isArray(cart?.discount_codes)) { owner.cartHydrationFailed = false; owner.cartHydrating = false; }
              owner.sync();
              return result;
            };
            this.host.renderCart = this.renderHook;
            this.host.renderTotals = this.totalsHook;
            this.stateObserver = new MutationObserver(() => {
              if (this.host.getAttribute('data-gdab-state') === 'cart') this.refreshCurrent();
            });
            this.stateObserver.observe(this.host, { attributes: true, attributeFilter: ['data-gdab-state'] });
            if (this.host._lastCart) this.host.renderTotals(this.host._lastCart);
            else this.sync();
          });
        }
        this.sync();
        if (this.cartHydrating) this.hydrateCart();
      }
      async hydrateCart() {
        if (this.cartHydrationAbort) return;
        const snapshot = this.cartData;
        const controller = this.cartHydrationAbort = new AbortController();
        this.cartHydrating = true;
        this.cartHydrationFailed = false;
        this.sync();
        const timer = setTimeout(() => controller.abort(), 6000);
        try {
          const response = await fetch(this.dataset.cartJsonUrl, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }, signal: controller.signal });
          if (!response.ok) throw new Error('cart_unavailable');
          const cart = await response.json();
          if (!Array.isArray(cart?.items)) throw new Error('cart_unavailable');
          if (this.cartData === snapshot) {
            this.cartData = cart;
            if (this.host?.state === 'cart') this.host.renderCart(cart);
          }
        } catch {
          if (this.cartData === snapshot) this.cartHydrationFailed = true;
        } finally {
          clearTimeout(timer);
          this.cartHydrationAbort = null;
          this.cartHydrating = false;
          if (this.isConnected) this.sync();
        }
      }
      mergeMaps(root) {
        const found = new Set();
        root.querySelectorAll('[data-cart-inventory-map]').forEach(script => {
          try {
            JSON.parse(script.textContent).filter(Boolean).forEach(record => {
              if (record.id && typeof record.available === 'boolean') {
                this.map.set(String(record.id), record);
                found.add(String(record.id));
              }
            });
          } catch {}
        });
        return found;
      }
      available(record) {
        if (!record) return null;
        if (record.handle === 'chest-bag-magnetic-dock') return record.available && (window.NexDock?.config.available ?? true);
        return record.available;
      }
      context(form, variantId, record) {
        if (!form.dataset.cartUniqueId) {
          const prefix = `CartNotify-${this.dataset.mode}-${++formSequence}`;
          const ids = new Map();
          form.querySelectorAll('[id]').forEach(node => { const old = node.id; node.id = `${prefix}-${ids.size}`; ids.set(old, node.id); });
          form.querySelectorAll('[for], [aria-describedby], [form]').forEach(node => {
            ['for', 'aria-describedby', 'form'].forEach(attribute => {
              if (node.hasAttribute(attribute)) node.setAttribute(attribute, node.getAttribute(attribute).split(/\s+/).map(id => ids.get(id) || id).join(' '));
            });
          });
          form.dataset.cartUniqueId = prefix;
        }
        const key = `${record.handle || ''}:${variantId}`;
        if (form.dataset.cartContextKey === key) return;
        form.dataset.cartContextKey = key;
        const context = { variantId, productHandle: record.handle || '', color: record.color || '' };
        form.dataset.notifyVariantId = variantId;
        form.dataset.notifyProductHandle = context.productHandle;
        form.dataset.notifyColor = context.color;
        const set = () => {
          if (form.isConnected && form.dataset.cartContextKey === key) form.setContext?.(context);
        };
        if (typeof form.setContext === 'function') set();
        else customElements.whenDefined('nex-preorder-notify').then(set);
      }
      sync() {
        if (!this.isConnected || !this.scope || !this.map) return;
        const cart = this.cartData || { items: [] };
        const items = new Map((cart.items || []).filter(Boolean).map(item => [String(item.key || item.variant_id || item.id), item]));
        const unknown = new Set();
        let soldOut = false;
        this.scope.querySelectorAll('.gdab__cart-lines > .gdab__cart-line').forEach(line => {
          const item = items.get(line.dataset.lineKey);
          const variantId = String(item?.variant_id || item?.id || line.dataset.variantId || '');
          if (!variantId || line.classList.contains('gdab__cart-line--skel') || line.classList.contains('gdab__cart-line--pending')) return;
          line.dataset.variantId = variantId;
          const record = this.map.get(variantId);
          const available = this.available(record);
          if (available === null) unknown.add(variantId);
          const sold = available === false;
          soldOut ||= sold;
          if (record) {
            const color = String(record.color || '');
            const label = line.querySelector('.gdab__cart-line-color');
            if (label) label.textContent = color ? color.charAt(0).toUpperCase() + color.slice(1).toLowerCase() : '';
            line.dataset.productHandle = record.handle || '';
            const remove = line.querySelector('[data-cart-inventory-remove]');
            if (remove) remove.setAttribute('aria-label', `${this.dataset.removeCopy} — ${line.querySelector('.gdab__cart-line-name')?.textContent || ''} ${color}`.trim());
            const form = line.querySelector('nex-preorder-notify');
            if (form) this.context(form, variantId, record);
          }
          line.classList.toggle('is-inventory-sold-out', sold);
          if (item && window.NexDock?.isDock(item)) {
            const dock = window.NexDock;
            const parent = items.get(item.parent_relationship?.parent_key);
            const free = typeof dock.isFree === 'function' ? dock.isFree(item) : item.final_line_price === 0;
            line.classList.toggle('is-dock-nested', Boolean(parent));
            line.classList.toggle('is-dock-free', free);
            line.classList.toggle('is-dock-paid', !free);
            const note = line.querySelector('.gdab__cart-line-cancel');
            if (note) note.textContent = free ? dock.config.copy.giftIncluded : this.dataset.addonCopy;
            const plus = line.querySelector('.gdab__step--plus');
            const minus = line.querySelector('.gdab__step--minus');
            for (const control of [plus, minus].filter(Boolean)) {
              control.setAttribute('aria-disabled', 'true');
              if (control.tagName === 'BUTTON') control.disabled = true;
            }
          }
        });
        const cartReady = !this.cartHydrating && !this.cartHydrationFailed;
        const verifyCart = cartReady && (cart.items?.length > 0 || Array.isArray(cart.discount_codes));
        const dockInvalid = verifyCart && (window.NexDock?.cartNeedsRepair(cart) || false);
        const giftInvalid = this.giftInvalid = verifyCart && (window.NexDock?.cartGiftError(cart) || false);
        const changeFailed = Boolean(this.host?._changeRetry);
        const changing = Boolean(this.dockChanging || this.pageReloading || this.host?.cartMutationActive?.() || this.host?._changeRetry || window.NexDock?.busy);
        this.blocked = !cartReady || soldOut || unknown.size > 0 || this.refreshingKnown || this.freshnessFailed || changing || this.dockRepairing || this.dockRepairFailed || dockInvalid || giftInvalid;
        if (dockInvalid && !changing && !this.dockRepairing && !this.dockRepairFailed && !window.NexDock.readOnly) {
          this.dockRepairing = true;
          window.NexDock.reconcileCart(cart).then(next => {
            this.cartData = next;
            if (this.host) this.host.renderCart(next);
            else { this.pageReloading = true; location.reload(); }
          }).catch(error => {
            this.dockRepairFailed = true;
            this.dockRepairMessage = error.message;
            if (error.cart) {
              this.cartData = error.cart;
              if (this.host) this.host.renderCart(error.cart);
            }
          }).finally(() => {
            this.dockRepairing = false;
            this.sync();
          });
        }
        const empty = !cart.items?.length;
        const nativeDisabled = this.dataset.mode === 'page' ? empty : this.nativeDisabled !== false;
        const dead = nativeDisabled || this.blocked;
        const checkout = this.scope.querySelector('.gdab__checkout');
        if (checkout && checkout.tagName === 'BUTTON') {
          checkout.disabled = dead;
          checkout.classList.toggle('is-disabled', dead);
          if (dead) { checkout.setAttribute('aria-disabled', 'true'); checkout.setAttribute('tabindex', '-1'); }
          else { checkout.removeAttribute('aria-disabled'); checkout.removeAttribute('tabindex'); }
        }
        const foot = this.scope.querySelector('.gdab__cart-foot');
        foot?.toggleAttribute('data-inventory-blocked', this.blocked);
        const express = this.scope.querySelector('[data-cart-shop-pay]');
        if (express) {
          express.hidden = this.blocked || empty;
          express.inert = dead;
          express.classList.toggle('is-disabled', dead);
          if (dead) express.setAttribute('aria-hidden', 'true'); else express.removeAttribute('aria-hidden');
        }
        const feedback = this.scope.querySelector('[data-cart-inventory-feedback]');
        if (feedback) {
          feedback.hidden = !this.blocked;
          feedback.textContent = soldOut ? this.dataset.unavailableCopy : giftInvalid ? window.NexDock.config.copy.giftPricingError : changeFailed ? (this.host._changeRetry.message || this.dataset.retryCopy) : this.dockRepairFailed ? (this.dockRepairMessage || this.dataset.repairCopy || this.dataset.retryCopy) : this.lookupFailed || this.cartHydrationFailed ? this.dataset.retryCopy : this.dataset.checkingCopy;
          if ((this.lookupFailed || this.cartHydrationFailed || this.dockRepairFailed || giftInvalid || changeFailed) && !this.lookupPending && !this.dockRepairing && !this.host?._changing) {
            const retry = document.createElement('button');
            retry.type = 'button';
            retry.className = 'gdab__cart-inventory-retry';
            retry.setAttribute('data-cart-inventory-retry', '');
            retry.textContent = this.dataset.retryLabel;
            feedback.append(retry);
          }
        }
        if (unknown.size) this.refreshMetadata([...unknown].sort().join(','));
      }
      refreshCurrent() {
        if (!this.isConnected) return;
        if (this.lookupPending) { this.refreshQueued = true; return; }
        const ids = [...new Set((this.cartData?.items || []).filter(Boolean).map(item => String(item.variant_id || item.id)))].sort();
        if (!ids.length) return;
        this.lookupSignature = '';
        this.refreshMetadata(ids.join(','), true);
      }
      async refreshMetadata(signature, known = false) {
        if (this.lookupPending || this.lookupSignature === signature) return;
        this.lookupSignature = signature;
        this.lookupPending = true;
        this.lookupFailed = false;
        this.refreshingKnown = known;
        this.lookupAbort = new AbortController();
        const controller = this.lookupAbort;
        const timer = setTimeout(() => controller.abort(), 6000);
        if (known) this.sync();
        try {
          const response = await fetch(this.dataset.cartUrl, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'text/html' }, signal: controller.signal });
          if (!response.ok) throw new Error('inventory_unavailable');
          const document = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (!document.querySelector('[data-cart-inventory-map]')) throw new Error('inventory_unavailable');
          const found = this.mergeMaps(document);
          const currentIds = (this.cartData?.items || []).filter(Boolean).map(item => String(item.variant_id || item.id));
          this.lookupFailed = currentIds.some(id => !found.has(id));
        } catch { this.lookupFailed = true; }
        finally {
          clearTimeout(timer);
          this.lookupPending = false;
          this.refreshingKnown = false;
          if (known) this.freshnessFailed = this.lookupFailed;
          if (this.isConnected) {
            this.sync();
            if (this.refreshQueued) { this.refreshQueued = false; this.refreshCurrent(); }
          }
        }
      }
      removalFocus(line) {
        const restore = line.contains(document.activeElement);
        const index = [...this.scope.querySelectorAll('.gdab__cart-lines > .gdab__cart-line')].indexOf(line);
        return () => {
          if (!restore || !this.isConnected || (this.host && this.host.state !== 'cart')) return;
          const visible = node => node && !node.disabled && node.getClientRects().length > 0 && getComputedStyle(node).visibility !== 'hidden';
          if (this.scope.contains(document.activeElement) && visible(document.activeElement)) return;
          const lines = [...this.scope.querySelectorAll('.gdab__cart-lines > .gdab__cart-line')];
          const next = lines[Math.min(Math.max(0, index), lines.length - 1)];
          const target = next && (next.classList.contains('is-inventory-sold-out')
            ? next.querySelector('[data-cart-inventory-remove]') : next.querySelector('.gdab__step'));
          const fallback = this.scope.querySelector('.gdab__cart-close');
          (visible(target) ? target : fallback)?.focus({ preventScroll: true });
        };
      }
      async changeDockLine(line, quantity, change = window.NexDock?.changeDockQuantity) {
        if (this.dockChanging || this.pageReloading || typeof change !== 'function') return;
        this.dockChanging = true;
        this.dockRepairFailed = false;
        this.sync();
        try {
          this.cartData = await change(this.cartData, line.dataset.lineKey, quantity);
          this.pageReloading = true;
          location.reload();
        } catch (error) {
          if (error.cart) this.cartData = error.cart;
          this.dockRepairFailed = true;
          this.dockRepairMessage = error.message;
        } finally {
          this.dockChanging = false;
          this.sync();
        }
      }
      onClick(event) {
        if (((this.cartHydrating || this.dockRepairing || this.dockChanging || this.pageReloading || window.NexDock?.busy) && event.target.closest('.gdab__step, [data-cart-inventory-remove]'))
          || event.target.closest('.gdab__step[aria-disabled="true"]')
          || (window.NexDock?.readOnly && event.target.closest('.gdab__step, [data-cart-inventory-remove], .gdab__checkout, [data-cart-shop-pay]'))) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const retry = event.target.closest('[data-cart-inventory-retry]');
        if (retry && this.scope.contains(retry)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const feedback = retry.closest('[data-cart-inventory-feedback]');
          if (feedback) { feedback.tabIndex = -1; feedback.focus({ preventScroll: true }); }
          if (this.host?._changeRetry) {
            this.host.retryChange();
            return;
          }
          this.dockRepairFailed = false;
          this.dockRepairMessage = '';
          this.hydrateCart();
          if (this.host?.refreshOpenCart) this.host.refreshOpenCart();
          else location.reload();
          this.refreshCurrent();
          return;
        }
        const quantityControl = event.target.closest('.gdab__step, [data-cart-inventory-remove]');
        if (this.dataset.mode === 'page' && quantityControl && this.scope.contains(quantityControl)
          && window.NexDock) {
          const line = quantityControl.closest('.gdab__cart-line');
          const item = this.cartData?.items?.find(entry => String(entry.key) === line?.dataset.lineKey);
          const change = item && (window.NexDock.isDock(item) ? window.NexDock.changeDockQuantity
            : window.NexDock.isBag?.(item) ? window.NexDock.changeBagQuantity : null);
          if (typeof change === 'function') {
            event.preventDefault();
            event.stopImmediatePropagation();
            const quantity = quantityControl.matches('[data-cart-inventory-remove]') ? 0
              : Math.max(0, Number(item.quantity) + (quantityControl.classList.contains('gdab__step--plus') ? 1 : -1));
            this.changeDockLine(line, quantity, change);
            return;
          }
        }
        const remove = event.target.closest('[data-cart-inventory-remove]');
        if (remove && this.scope.contains(remove)) {
          const line = remove.closest('.gdab__cart-line');
          if (!line) return;
          const restoreFocus = this.removalFocus(line);
          if (this.dataset.mode === 'drawer') {
            event.preventDefault();
            event.stopImmediatePropagation();
            if (!this.host?._changing && typeof this.host?.changeLine === 'function') {
              Promise.resolve(this.host.changeLine(line, 0)).then(restoreFocus, restoreFocus);
            }
          }
          return;
        }
        const express = event.target.closest('[data-cart-shop-pay]');
        if (express && this.scope.contains(express)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (this.blocked || express.inert || express.hidden || !this.cartData?.items?.length
            || window.NexDock?.readOnly || window.NexPurchaseReview) return;
          location.assign(this.dataset.shopPayUrl);
          return;
        }
        if ((this.blocked || window.NexDock?.readOnly) && event.target.closest('.gdab__checkout')) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }
      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.ready);
        this.lineObserver?.disconnect(); this.stateObserver?.disconnect(); this.lookupAbort?.abort(); this.cartHydrationAbort?.abort();
        window.removeEventListener('pageshow', this.recheck); window.removeEventListener('focus', this.recheck);
        this.scope?.removeEventListener('click', this.click, true); this.scope?.removeEventListener('submit', this.submit, true);
        this.refreshQueued = false;
        if (this.host && this.host.renderCart === this.renderHook) this.host.renderCart = this.originalRender;
        if (this.host && this.host.renderTotals === this.totalsHook) this.host.renderTotals = this.originalTotals;
        this.started = false;
      }
    }
    customElements.define('nex-cart-inventory', NexCartInventory);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gdab"] && !Shopify.designMode) return;
  try {
    (() => {
    const bootPillCompare = () => {
      document.querySelectorAll("nex-gdab").forEach((scope) => {
        if (scope._pillCompareWired) return;
        const compare = scope.querySelector("[data-gdab-compare]");
        if (!compare) return;
        scope._pillCompareWired = true;
        const sync = () => {
          const card = scope.querySelector('.gdab__card[aria-checked="true"]');
          const value = card && card.dataset.comparePrice;
          if (value && compare.textContent !== value) compare.textContent = value;
        };
        new MutationObserver(sync).observe(scope, {
          subtree: true,
          attributes: true,
          attributeFilter: ["aria-checked"],
        });
        sync();
      });
    };
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", bootPillCompare, { once: true });
    } else {
      bootPillCompare();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["low-stock-indicator"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get("nex-low-stock")) return;

    class NexLowStock extends HTMLElement {
      connectedCallback() {
        if (this._inventoryConnected) return;
        this._inventoryConnected = true;
        this._inventoryReady = () => {
          this._inventoryReady = null;
          if (this.isConnected) this.connectInventory();
        };
        if (document.readyState === "loading") {
          document.addEventListener("DOMContentLoaded", this._inventoryReady, { once: true });
        } else {
          this._inventoryReady();
        }
      }

      connectInventory() {
        this._inventoryContent = this.querySelector("[data-low-stock-content]");
        this._inventoryTemplates = new Map(
          [...this.querySelectorAll("template[data-low-stock-variant]")].map((template) => [
            template.dataset.lowStockVariant,
            template,
          ]),
        );
        this._inventoryScope = this.closest("nex-hero-purchase, nex-gdab");
        if (!this._inventoryContent || !this._inventoryScope) return;
        this._inventoryObserver = new MutationObserver(() => this.syncInventory());
        this._inventoryObserver.observe(this._inventoryScope, {
          subtree: true,
          attributes: true,
          attributeFilter: [
            "aria-checked",
            "data-variant-id",
            "aria-disabled",
            "disabled",
            "data-unavailable",
          ],
        });
        this.syncInventory();
      }

      syncInventory() {
        const selected = this._inventoryScope.querySelector(
          '.hero-purchase__color[aria-checked="true"], .gdab__card[aria-checked="true"]',
        );
        const available = selected && !selected.disabled
          && selected.getAttribute("aria-disabled") !== "true"
          && !selected.hasAttribute("data-unavailable");
        const variantId = available ? selected.dataset.variantId || "" : "";
        const template = this._inventoryTemplates.get(variantId);
        if (this.dataset.variantId !== variantId) this.dataset.variantId = variantId;
        if (!template) {
          this.hidden = true;
          if (this._inventoryContent.childNodes.length) this._inventoryContent.replaceChildren();
          this._inventoryRenderedVariant = "";
          return;
        }
        if (this._inventoryRenderedVariant !== variantId) {
          this._inventoryContent.replaceChildren(template.content.cloneNode(true));
          this._inventoryRenderedVariant = variantId;
        }
        this.hidden = false;
      }

      disconnectedCallback() {
        if (this._inventoryReady) {
          document.removeEventListener("DOMContentLoaded", this._inventoryReady);
        }
        this._inventoryObserver?.disconnect();
        this._inventoryConnected = false;
        this._inventoryReady = null;
        this._inventoryObserver = null;
        this._inventoryScope = null;
        this._inventoryContent = null;
        this._inventoryTemplates = null;
        this._inventoryRenderedVariant = "";
      }
    }

    customElements.define("nex-low-stock", NexLowStock);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["preorder-notify"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get("nex-preorder-notify")) return;
    const confirmed = new Map();

    class NexPreorderNotify extends HTMLElement {
      connectedCallback() {
        if (this._connected) return;
        this._connected = true;
        this._abort = new AbortController();
        this._ready = () => {
          if (this.isConnected) this.connect();
        };
        if (document.readyState === "loading") {
          document.addEventListener("DOMContentLoaded", this._ready, { once: true, signal: this._abort.signal });
        } else {
          this.connect();
        }
      }

      connect() {
        this.form = this.querySelector("form");
        this.track = this.querySelector("[data-notify-track]");
        this.button = this.querySelector("[data-notify-button]");
        this.label = this.querySelector("[data-notify-button-label]");
        this.email = this.querySelector("[data-notify-email]");
        this.status = this.querySelector("[data-notify-status]");
        if (!this.form || !this.track || !this.button || !this.label || !this.email || !this.status) return;
        const options = { signal: this._abort.signal };
        this.form.addEventListener("submit", (event) => this.submit(event), options);
        this.button.addEventListener("click", () => {
          if (this.dataset.state !== "editing") return;
          this.email.setCustomValidity("");
          this.email.removeAttribute("aria-invalid");
        }, options);
        this.email.addEventListener("input", () => {
          this.email.setCustomValidity("");
          this.email.removeAttribute("aria-invalid");
          this.status.textContent = "";
        }, options);
        this.addEventListener("keydown", (event) => {
          if (event.key === "Escape" && this.dataset.state === "editing" && !this.email.value.trim()) {
            event.preventDefault();
            event.stopPropagation();
            this.reset();
            this.button.focus({ preventScroll: true });
          }
        }, options);
        document.addEventListener("nex:preorder-notify-success", (event) => {
          const email = this.email.value.trim().toLowerCase();
          if (event.detail?.key === this.contextKey() && (!email || email === event.detail.email)) this.showSuccess();
        }, options);
        this._resize = new ResizeObserver(() => this.measure());
        [this.track, this.button].forEach((node) => this._resize.observe(node));
        this.setContext(this.context || {
          variantId: this.dataset.notifyVariantId,
          productHandle: this.dataset.notifyProductHandle,
          color: this.dataset.notifyColor,
        });
        if (document.fonts?.ready) document.fonts.ready.then(() => { if (this.isConnected) this.measure(); });
      }

      setContext(context = {}) {
        const previous = this.contextKey();
        this.context = {
          variantId: String(context.variantId || ""),
          productHandle: String(context.productHandle || ""),
          color: String(context.color || ""),
        };
        if (!this.form) return;
        if (previous !== this.contextKey() || !this._initialized) {
          this._initialized = true;
          this.reset();
        }
        const emails = confirmed.get(this.contextKey());
        const email = this.email.value.trim().toLowerCase();
        if (emails && (!email || emails.has(email))) this.showSuccess();
      }

      contextKey() {
        const context = this.context || {};
        return `${context.productHandle || ""}:${context.variantId || context.color || this.form?.id || ""}`;
      }

      measure() {
        if (!this.track || !this.button) return;
        const width = this.track.clientWidth;
        if (!width) return;
        const buttonWidth = this.button.offsetWidth;
        const state = this.dataset.state;
        const buttonShift = state === "success" ? 6 - (width - buttonWidth) / 2 : 0;
        this.style.setProperty("--notify-button-width", `${buttonWidth}px`);
        this.style.setProperty("--notify-button-shift", `${buttonShift}px`);
        if (!this.hasAttribute("data-notify-positioned") && !this._measureFrame) {
          this._measureFrame = requestAnimationFrame(() => {
            this._measureFrame = null;
            if (this.isConnected) this.setAttribute("data-notify-positioned", "");
          });
        }
      }

      setState(state) {
        clearTimeout(this._hideEmailTimer);
        this.email.hidden = false;
        this.dataset.state = state;
        const editing = state === "editing" || state === "submitting";
        this.email.disabled = !editing;
        this.email.setAttribute("aria-hidden", String(!editing));
        this.email.readOnly = state === "submitting";
        this.button.type = editing ? "submit" : "button";
        this.button.disabled = state === "submitting" || state === "success";
        this.button.setAttribute("aria-label", state === "submitting" ? this.dataset.notifySubmitting
          : state === "success" ? this.dataset.notifySuccess : this.dataset.notifyLabel);
        this.form.setAttribute("aria-busy", String(state === "submitting"));
        this.measure();
        if (state === "success") {
          this._hideEmailTimer = setTimeout(() => {
            if (this.dataset.state !== "success") return;
            this.email.hidden = true;
            this.email.value = "";
          }, matchMedia("(prefers-reduced-motion: reduce)").matches ? 0 : 500);
        }
      }

      open({ focus = false } = {}) {
        if (!this.email || this.dataset.state === "success" || this.dataset.state === "submitting") return;
        this.setState("editing");
        if (focus) this.email.focus({ preventScroll: true });
      }

      reset({ forgetSuccess = false } = {}) {
        if (!this.form) return;
        if (forgetSuccess) confirmed.delete(this.contextKey());
        this._submission = null;
        this.email.value = "";
        this.email.setCustomValidity("");
        this.email.removeAttribute("aria-invalid");
        this.label.textContent = this.dataset.notifyLabel;
        this.status.textContent = "";
        this.setState("editing");
      }

      requestSubscription() {
        let resolve;
        let reject;
        const promise = new Promise((fulfill, fail) => { resolve = fulfill; reject = fail; });
        const request = new CustomEvent("nex:preorder-notify-submit", {
          bubbles: true,
          cancelable: true,
          detail: { form: this.form, context: { ...this.context }, resolve, reject },
        });
        const handled = !this.dispatchEvent(request);
        if (!handled) reject(new Error("Notification transport is unavailable"));
        return { handled, promise };
      }

      submit(event) {
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (this.dataset.state !== "editing") {
          return;
        }
        if (!this.form.reportValidity()) {
          return;
        }
        const submission = { key: this.contextKey(), email: this.email.value.trim().toLowerCase() };
        this._submission = submission;
        const request = this.requestSubscription();
        this.status.textContent = this.dataset.notifySubmitting;
        this.setState("submitting");
        request.promise.then((result) => {
          if (!this.isConnected || this._submission !== submission || this.contextKey() !== submission.key) return;
          if (result?.verified !== true) throw new Error("Unverified subscription result");
          if (!confirmed.has(submission.key)) confirmed.set(submission.key, new Set());
          confirmed.get(submission.key).add(submission.email);
          document.dispatchEvent(new CustomEvent("nex:preorder-notify-success", { detail: { key: submission.key, email: submission.email } }));
        }).catch((error) => {
          if (!this.isConnected || this._submission !== submission || this.contextKey() !== submission.key) return;
          const message = typeof error?.userMessage === "string" ? error.userMessage : this.dataset.notifyError;
          this.setState("editing");
          this.status.textContent = message;
          this.email.setCustomValidity(message);
          this.email.setAttribute("aria-invalid", "true");
          if (!this.hidden && this.getClientRects().length) {
            this.email.focus({ preventScroll: true });
            this.email.reportValidity();
          }
        });
      }

      showSuccess() {
        if (!this.label) return;
        this._submission = null;
        this.email.setCustomValidity("");
        this.email.removeAttribute("aria-invalid");
        this.label.textContent = this.dataset.notifySuccess;
        this.status.textContent = this.dataset.notifySuccess;
        this.setState("success");
      }

      disconnectedCallback() {
        this._abort?.abort();
        this._resize?.disconnect();
        clearTimeout(this._hideEmailTimer);
        if (this._measureFrame) cancelAnimationFrame(this._measureFrame);
        this._measureFrame = null;
        this._connected = false;
        this._initialized = false;
        this._submission = null;
      }
    }

    customElements.define("nex-preorder-notify", NexPreorderNotify);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["price-compare"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('nex-price-compare')) return;
  class NexPriceCompare extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this._ready = () => this.mount();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this._ready, { once: true });
      else this.mount();
    }
    mount() {
      this.content = this.querySelector('[data-price-compare-content]');
      this.scope = this.closest('nex-hero-purchase, nex-gdab');
      if (!this.content || !this.scope) return;
      this.templates = new Map([...this.querySelectorAll('template[data-price-compare-variant]')].map(node => [node.dataset.priceCompareVariant + ':' + node.dataset.priceCompareMode, node]));
      this.observer = new MutationObserver(() => this.syncCompare());
      this.observer.observe(this.scope, { subtree: true, attributes: true, attributeFilter: ['aria-checked', 'data-inventory-available', 'data-preorder', 'data-dock-state'] });
      this.syncCompare();
    }
    syncCompare() {
      if (!this.scope || !this.content) return;
      const card = this.scope.querySelector('.hero-purchase__color[aria-checked="true"], .gdab__card[aria-checked="true"]');
      const available = card?.dataset.inventoryAvailable === 'true';
      const preorder = card?.dataset.preorder === 'true';
      const gift = this.scope.dataset.dockState === 'gift';
      const mode = !preorder ? 'stock' : gift ? 'gift' : 'preorder';
      const key = available ? card.dataset.variantId + ':' + mode : '';
      const template = this.templates.get(key);
      if (!template) {
        this.hidden = true;
        this.rendered = '';
        if (this.content.childNodes.length) this.content.replaceChildren();
        this.syncPill(card, '');
        return;
      }
      if (this.rendered !== key) {
        this.content.replaceChildren(template.content.cloneNode(true));
        this.rendered = key;
      }
      this.hidden = false;
      this.syncPill(card, preorder ? this.content.querySelector('[data-price-after]')?.textContent || '' : '');
    }
    syncPill(card, value) {
      if (card && card.dataset.comparePrice !== value) card.dataset.comparePrice = value;
      if (card && card.dataset.compare !== value) card.dataset.compare = value;
      const strike = this.scope.querySelector('[data-gdab-compare]');
      if (strike) {
        strike.hidden = !value;
        strike.style.display = value ? '' : 'none';
        if (value && strike.textContent !== value) strike.textContent = value;
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('DOMContentLoaded', this._ready);
      this._connected = false;
    }
  }
  customElements.define('nex-price-compare', NexPriceCompare);
})();
  } catch(e) { console.error(e); }
})();

})();
